import Glide from '@glidejs/glide';

function newProdSlider(response) {
  $('.product-carousel').removeClass('.glide--ltr, .glide--carousel, .glide--swipeable');
  $('.product-carousel #results').attr('style', '');
  $('.product-carousel #results').html(response);

  setTimeout(function() {
    if($(window).width() >= 768) {
      new Glide('.product-carousel', {
        type: 'carousel',
        startAt: 0,
        perView: 4,
        animationTimingFunc: 'cubic-bezier(0.5, 0, 0, 1)',
        gap: 65,
      }).mount();
    }
  }, 200);

  setTimeout(function() {
    $('.product-carousel').removeClass('loading');
    $('.product-carousel li').addClass('onscreen');
  }, 800);
}

function doHomeSearch() {
  $('.product-carousel').addClass('loading');
  var filterby = $('select.filterby').val();
  var sortby = $('select.sortby').val();
  $.ajax({
    type: 'POST',
    url: '/wp/wp-admin/admin-ajax.php',
    data: {
      action: 'home_products',
      selected_cat: filterby,
      sort_by: sortby,
    },
    success: function(response) {
      newProdSlider(response);
      window.yotpo.initWidgets();
    },
    error: function() {
      $('#results').removeClass('loading');
    },
  });
  return false;
}

export default {
  init() {
    // JavaScript to be fired on the home page
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
    $(window).load(function() {
      if($(window).width() >= 768) {
        new Glide('.product-carousel', {
          type: 'carousel',
          startAt: 0,
          perView: 4,
          animationTimingFunc: 'cubic-bezier(0.5, 0, 0, 1)',
          gap: 65,
        }).mount();
      }

      new Glide('.hero-carousel', {
        type: 'carousel',
        startAt: 0,
        perView: 1,
        gap: 0,
        autoplay: 5000,
        animationTimingFunc: 'cubic-bezier(0.5, 0, 0, 1)',
      }).mount();

      if($(window).width() <= 768) {
        $('.home-cta .cta-left-img').height($('.home-cta .cta-right-content ul').height());
      }
    });

    $('select.filterby').change(function() {
      doHomeSearch();
    });

    $('select.sortby').change(function() {
      doHomeSearch();
    });

    $('.home-intro .mobile-show-next').click(function(e) {
      e.preventDefault();
      $(this).parent().next().removeClass('hide-on-mobile');
      $(this).hide();
    });
  },
};

$(window).load(function () {
    $('.hero .glide__slide').each(function () {
        if ($(window).width() >= 768) {
            $(this).css('background-image', 'url(' + $(this).data('background') + ')');
        } else {
            $(this).css('background-image', 'url(' + $(this).data('background-mobile') + ')');
        }
    });

    if($('.header-sale-banner').is(':visible')){
        $('.hero .glide__slides').height($('.hero .glide__slides').height() - $('.header-sale-banner').height() - $('header.banner').height());
    }else{
        $('.hero .glide__slides').height($('.hero .glide__slides').height() - $('header.banner').height());
    }

});




// WEBPACK FOOTER //
// ./scripts/routes/home.js